<!-- <ngb-toast *ngFor="let toast of toastService.toasts" [class]="toast.classname" [autohide]="true"
    [delay]="toast.delay || 5000" (hidden)="toastService.remove(toast)">
    <ngb-toast header="Notification header">
        success
    </ngb-toast>
    <ng-template [ngIf]="isTemplate(toast)" [ngIfElse]="text">
        <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
    </ng-template>
    <ng-template #text>{{ toast.textOrTpl }}</ng-template>
</ngb-toast> -->

<ngb-toast *ngFor="let toast of toastService.toasts" [class]="toast.classname" [autohide]="true" >
    <ng-template ngbToastHeader>
        <div class="me-auto">
            <i [class]="toast.icon"></i>
            <strong class="mx-1">{{toast.header}}</strong>
        </div>
    </ng-template>
    {{toast.text}}
</ngb-toast>